/**
 * Capitulos navegables de la pagina /planes-y-beneficios.
 * Cada seccion tiene su data-testid en el JSX y la PricingProgressBar
 * los lee para colocar mini-marcadores tipo YouTube en la barra superior.
 */
export const PRICING_SECTIONS = [
  { id: 'free-plan-section',     label: { es: 'Free',     en: 'Free' },     color: 'cyan' },
  { id: 'premium-plan-section',  label: { es: 'Premium',  en: 'Premium' },  color: 'amber' },
  { id: 'advanced-plan-section', label: { es: 'Avanzado', en: 'Advanced' }, color: 'emerald' },
  { id: 'prohibitions-section',  label: { es: 'Reglas',   en: 'Rules' },    color: 'rose' },
];

export const SECTION_DOT_COLOR = {
  cyan: 'bg-cyan-300',
  amber: 'bg-amber-300',
  emerald: 'bg-emerald-300',
  rose: 'bg-rose-300',
};
